import type { CardList } from '../../../models/layout.model';

const normalizedCardType = (cardType: CardList['cardType']): string =>
	String(cardType ?? '')
		.trim()
		.toLowerCase();

export const changedCardTypeIds = (
	previousCards: CardList[],
	nextCards: CardList[]
): Set<string> => {
	const previousTypeByCardId = new Map(
		previousCards.map(card => [
			card.cardId,
			normalizedCardType(card.cardType),
		])
	);
	const changedIds = new Set<string>();

	for (const card of nextCards) {
		if (!previousTypeByCardId.has(card.cardId)) {
			continue;
		}
		if (
			previousTypeByCardId.get(card.cardId) !==
			normalizedCardType(card.cardType)
		) {
			changedIds.add(card.cardId);
		}
	}

	return changedIds;
};
